<template>
    
    <div class="main">
        <c-panel>
            <form-curso :paramId="$route.params.id" v-on:onSubmitCurso="onSubmitCurso"></form-curso>
        </c-panel>
    </div>
    
</template>
<script>

import formCurso from "./form"

export default {
    methods:{

        onSubmitCurso(){

            this.$router.push('/admin/curso');  
        }
    },
    components:{ formCurso }
}
</script>
